/**
 * Partner Settlement API
 * 협력사 주정산내역 API
 */
import { apiClient } from "@/shared/api/client";
import {
    GetPartnerSettlementListResponseDto,
    GetLatestSettlementDateResponseDto,
    ApiResponseDto
} from "../types/partnerSettlement.types";
import { uploadSettlementFile, buildExcelDownloadUrl, downloadExcelFile } from "@/shared/utils/settlementApiHelpers";
import { formatDateToISO } from "@/shared/utils/dateUtils";

const BASE_PATH = '/api/v1/partner-settlement';

/**
 * Partner Settlement API 서비스
 */
export const partnerSettlementApi = {
    /**
     * 협력사 주정산내역 목록 조회
     * GET /api/v1/partner-settlement?startDate={startDate}endDate={endDate}&supplyId={id}
     */
    getPartnerSettlementList: async (
        acctStDate: string,
        acctEdDate: string,
        supplyId?: string
    ): Promise<GetPartnerSettlementListResponseDto> => {
        // 날짜를 ISO 형식(YYYY-MM-DD)으로 변환
        const formattedStDate = formatDateToISO(acctStDate);
        const formattedEdDate = formatDateToISO(acctEdDate);

        // URL을 직접 구성 - 조회일자 범위 내에 정산시작일이 포함되는 데이터 조회
        let url = `${BASE_PATH}?startDate=${formattedStDate}&endDate=${formattedEdDate}`;
        if (supplyId && supplyId !== 'ALL') {
            url += `&supplyId=${supplyId}`;
        }

        const response = await apiClient.get<GetPartnerSettlementListResponseDto>(url);
        return response.data;
    },

    /**
     * 최근 정산일자 조회 (시작일, 종료일)
     * GET /api/v1/partner-settlement/latest-date
     */
    getLatestSettlementDate: async (): Promise<GetLatestSettlementDateResponseDto> => {
        const response = await apiClient.get<GetLatestSettlementDateResponseDto>(`${BASE_PATH}/latest-date`);
        return response.data;
    },

    /**
     * 엑셀 다운로드
     * GET /api/v1/partner-settlement/excel?acctEdDate={date}&supplyId={id}
     */
    downloadExcel: async (acctEdDate: string, supplyId?: string): Promise<Blob> => {
        const url = buildExcelDownloadUrl(BASE_PATH, {
            acctEdDate,
            supplyId: supplyId !== 'ALL' ? supplyId : undefined
        });
        return downloadExcelFile(url);
    }
};
